import React from 'react';

import { Box, Button } from '@mui/material';

const DeclinedModal = (props) => {
    const { closeDecline, response, setResponse } = props;

    function handleClose() {
        closeDecline();
        setResponse(null);
    }
    return (
        <Box sx={{ width: '90%', m: '2vh auto', textAlign: 'center', display: 'flex', flexDirection: 'column' }}>
            <h2 style={{ color: 'white', fontWeight: 'bold' }}>Payment Declined</h2>
            <p style={{ color: 'white', fontWeight: 'bold' }}>Your payment was declined.</p>
            <p style={{ color: 'white', fontWeight: 'bold' }}>{response?.responseText || "UNKNOWN ERROR PLEASE CONTACT smartcollectmerchant@praeses.com"}<br /> Please try again.</p>
            <Button onClick={handleClose}
                sx={{
                    backgroundColor: 'black',
                    color: 'white',
                    mt: '2vh',
                    maxWidth: '25%',
                    alignSelf: "center",
                    "&:hover": {
                        backgroundColor: 'black',
                        boxShadow: '0px 0px 15px white'
                    }
                }}
                variant="contained"
            >
                Close
            </Button>
        </Box>
    )
}

export default DeclinedModal;